import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Hands the Apple Pay capture key to the native layer, which stores it in the
// Keychain for LogExpenseIntent — the "Log Expense" action the user picks in
// Shortcuts and Siri.
//
// The key is a value, not an action: it is sent on connect and never touched
// again. When capture is off Rails renders an empty key, and native deletes its
// copy, so an automation left on the phone fails immediately instead of posting
// with a secret the server has already destroyed.
//
// Nothing here checks `this.enabled` before sending, for the same reason
// app_icon_controller does not: this screen is reached as a fresh web view
// whose Stimulus controllers connect before the bridge adapter lands, and
// guarding on it would drop the message with no retry. `Bridge.send` already
// queues and replays, and drops messages on platforms without the component.
export default class extends BridgeComponent {
  static component = "capture-key"
  static values = { key: String }
  static targets = ["armed"]

  connect() {
    super.connect()
    this.send("connect", { key: this.keyValue || "" }, (message) => this.#onMessage(message))
  }

  // Native reports what actually landed in the Keychain. Only then does the
  // screen claim the phone is armed — the web side cannot know on its own
  // whether the write succeeded, or whether this is even a native session.
  #onMessage(message) {
    if (message?.event !== "state") return
    if (!this.hasArmedTarget) return

    this.armedTarget.hidden = !message.data?.stored
  }
}
